module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-27.7324bf05.png";